import { IWorkingSessionsAnalyticsActivityEnum } from '../../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { CubeAdapter } from '../../../../infrastructure/adapters/cube/cube.adapter';
import {
  ISelfFocusScoreGoalPersistenceResponse,
  SelfFocusScoreGoalMapper,
} from '../../../../infrastructure/mappers/goals/self-focus-score-goal.mapper';
import { GetSelfGoalSummaryRequestDto } from '../../../../interface/dtos/goals/get-self-goal-summaries.request.dto';
import { SelfFocusScoreGoalEntity } from '../../../domain/entities/goals/score-goals/self-focus-score-goal.entity';

export class GetSelfFocusScoreGoalService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly adapter: CubeAdapter,
    protected readonly mapper: SelfFocusScoreGoalMapper
  ) {}

  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfFocusScoreGoalEntity> {
    try {
      const [response]: ISelfFocusScoreGoalPersistenceResponse[] =
        await this.adapter.query(props.config.token, {
          measures: [IWorkingSessionsAnalyticsActivityEnum.FocusPercentage],
          timeDimensions: [
            {
              dimension:
                IWorkingSessionsAnalyticsActivityEnum.LocalSessionStart,
              dateRange: [props.goal.startDate, props.goal.endDate],
            },
          ],
        });

      const entity = response?.[
        IWorkingSessionsAnalyticsActivityEnum.FocusPercentage
      ]
        ? this.mapper.toDomain(response)
        : SelfFocusScoreGoalEntity.create({
            score: 0,
          });
      entity.setGoalValue(Number(props.goal.value));
      return entity;
    } catch (error) {
      throw new Error(
        `GetSelfFocusScoreGoalService.execute encountered an error ${error}`
      );
    }
  }
}
